import { CardStatus } from '@superthread-com/api';

const cardStatusType = {
  Backlog: 'backlog',
  Rolledover: 'rolledover',
  ...CardStatus,
} as const;

export default cardStatusType;
